"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'solid',
    name: 'Solid',
    background_color: '#c6cbce',
    background_image: 'https://assets.raydiant.com/images/solid.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/solid-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Poppins-Bold.woff',
    heading_text_color: '#1d94c6',
    heading_2_font: 'https://fonts.raydiant.com/Roboto-Bold.woff',
    heading_2_text_color: '#00739c',
    body_font: 'https://fonts.raydiant.com/Arimo-Regular.woff',
    body_text_color: '#051727',
    border_color: '#1d94c6',
};
//# sourceMappingURL=solid.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/solid.js